import { metrics } from '@atlassian/browser-metrics';

export const timeToRenderTransitionModal = metrics.interaction({
	key: 'issue.time-to.render-issue-transition-screen',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '500_1000_2500_4000_7000_10000',
	},
});
